import React from 'react';
import { Divider, Typography } from 'antd';
import portrait from '../../../Assets/ResearchLabs/RSGCRL/Director/Dr-Zia-ul-Haq.png';

const { Link, Text, Title } = Typography;

const PrincipalInvestigator = () => (
  <section className="sarl-director-section" aria-labelledby="rsgcrl-director-title">
    <div className="sarl-director-inner">
      <Title level={2} id="rsgcrl-director-title" className="sarl-director-title">
        Principal Investigator/Lab Director
      </Title>
      <Divider className="ncgsa-divider" />
      <img className="sarl-director-photo" src={portrait} alt="Dr. Zia ul Haq" />
      <div className="sarl-director-details">
        <Title level={3}>Dr. Zia ul Haq</Title>
        <Text strong>University of the Punjab</Text>
        <Link href="mailto:zia.spsc@pu.edu.pk">Email: zia.spsc@pu.edu.pk</Link>
        <Link href="tel:+924299233106">Phone: 042-99233106-7</Link>
      </div>
    </div>
  </section>
);

export default PrincipalInvestigator;
